import { render, staticRenderFns } from "./payService.vue?vue&type=template&id=40936448&scoped=true&"
import script from "./payService.vue?vue&type=script&lang=js&"
export * from "./payService.vue?vue&type=script&lang=js&"
import style0 from "./payService.vue?vue&type=style&index=0&id=40936448&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40936448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40936448')) {
      api.createRecord('40936448', component.options)
    } else {
      api.reload('40936448', component.options)
    }
    module.hot.accept("./payService.vue?vue&type=template&id=40936448&scoped=true&", function () {
      api.rerender('40936448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/payService.vue"
export default component.exports